'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Command as CommandPrimitive, useCommandState } from 'cmdk';
import { cn } from '@repo/ui/lib/utils';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@repo/ui/components/ui/dialog';
import { InputGroup, InputGroupAddon } from '@repo/ui/components/ui/input-group';
import { CheckIcon, SearchIcon } from 'lucide-react';
function Command(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex size-full flex-col overflow-hidden rounded-xl! bg-popover p-1 text-popover-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive className={t1} data-slot="command" {...props} data-sentry-element="CommandPrimitive" data-sentry-component="Command" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function CommandDialog(t0) {
  const $ = _c(24);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      children,
      className,
      description: t1,
      showCloseButton: t2,
      title: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const description = t1 === undefined ? "Search for a command to run..." : t1;
  const showCloseButton = t2 === undefined ? false : t2;
  const title = t3 === undefined ? "Command Palette" : t3;
  let t4;
  if ($[7] !== title) {
    t4 = <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="command.tsx">{title}</DialogTitle>;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="command.tsx">{description}</DialogDescription>;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <DialogHeader className="sr-only" data-sentry-element="DialogHeader" data-sentry-source-file="command.tsx">{t4}{t5}</DialogHeader>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== className) {
    t7 = cn("top-1/3 translate-y-0 overflow-hidden rounded-xl! p-0", className);
    $[14] = className;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== children || $[17] !== showCloseButton || $[18] !== t7) {
    t8 = <DialogContent className={t7} showCloseButton={showCloseButton} data-sentry-element="DialogContent" data-sentry-source-file="command.tsx">{children}</DialogContent>;
    $[16] = children;
    $[17] = showCloseButton;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props || $[21] !== t6 || $[22] !== t8) {
    t9 = <Dialog {...props} data-sentry-element="Dialog" data-sentry-component="CommandDialog" data-sentry-source-file="command.tsx">{t6}{t8}</Dialog>;
    $[20] = props;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function CommandEmpty(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("py-6 text-center text-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive.Empty className={t1} data-slot="command-empty" {...props} data-sentry-element="CommandPrimitive.Empty" data-sentry-component="CommandEmpty" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function CommandGroup(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive.Group className={t1} data-slot="command-group" {...props} data-sentry-element="CommandPrimitive.Group" data-sentry-component="CommandGroup" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function CommandInput(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("w-full text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive.Input className={t1} data-slot="command-input" {...props} data-sentry-element="CommandPrimitive.Input" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InputGroupAddon data-sentry-element="InputGroupAddon" data-sentry-source-file="command.tsx"><SearchIcon className="size-4 shrink-0 opacity-50" data-sentry-element="SearchIcon" data-sentry-source-file="command.tsx" /></InputGroupAddon>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2) {
    t4 = <div className="p-1 pb-0" data-slot="command-input-wrapper" data-sentry-component="CommandInput" data-sentry-source-file="command.tsx"><InputGroup className="h-8! rounded-lg! border-input/30 bg-input/30 shadow-none! *:data-[slot=input-group-addon]:pl-2!" data-sentry-element="InputGroup" data-sentry-source-file="command.tsx">{t2}{t3}</InputGroup></div>;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function CommandItem(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("group/command-item relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none in-data-[slot=dialog-content]:rounded-lg! data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected=true]:bg-muted data-[selected=true]:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[selected=true]:*:[svg]:text-foreground", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckIcon className="ml-auto opacity-0 group-has-data-[slot=command-shortcut]/command-item:hidden group-data-[checked=true]/command-item:opacity-100" data-sentry-element="CheckIcon" data-sentry-source-file="command.tsx" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <CommandPrimitive.Item className={t1} data-slot="command-item" {...props} data-sentry-element="CommandPrimitive.Item" data-sentry-component="CommandItem" data-sentry-source-file="command.tsx">{children}{t2}</CommandPrimitive.Item>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function CommandList(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("no-scrollbar max-h-72 scroll-py-1 overflow-x-hidden overflow-y-auto outline-none", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive.List className={t1} data-slot="command-list" {...props} data-sentry-element="CommandPrimitive.List" data-sentry-component="CommandList" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function CommandSeparator(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("-mx-1 h-px bg-border", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CommandPrimitive.Separator className={t1} data-slot="command-separator" {...props} data-sentry-element="CommandPrimitive.Separator" data-sentry-component="CommandSeparator" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function CommandShortcut(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ml-auto text-xs tracking-widest text-muted-foreground group-data-[selected=true]/command-item:text-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span className={t1} data-slot="command-shortcut" {...props} data-sentry-component="CommandShortcut" data-sentry-source-file="command.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut, useCommandState };